import React, { Fragment } from 'react';
import { bool, any, func, string } from 'prop-types';

import { SidebarMenu } from './sidebar-menu';
import SidebarHeader from '../../containers/sidebar-header';
import { Divider, SidebarWrapper } from './styled-components';


const sidebarLinksFirst = [
  {
    url: '/overview',
    text: 'Overview',
    icon: {
      size: 18,
      type: 'overview',
    },
  },
  {
    url: '/requests',
    text: 'Requests',
    icon: {
      size: 18,
      type: 'requests',
    },
  },
  {
    url: '/contacts',
    text: 'Contacts',
    icon: {
      size: 17,
      type: 'users',
    },
  },
  {
    url: '/companies',
    text: 'Companies',
    icon: {
      size: 17,
      type: 'companies',
    },
  },
  {
    url: '/tasks',
    text: 'Tasks',
    icon: {
      size: 18,
      type: 'tasks',
    },
  },
  {
    url: '/statistics',
    text: 'Statistics',
    icon: {
      size: 17,
      type: 'statistics',
    },
  },
];

const sidebarLinksSecond = [
  {
    url: '/meeting-notes',
    text: 'Meeting notes',
    icon: {
      size: 18,
      type: 'notes',
    },
  },
];

export const Sidebar = ({
  route: activeRoute,
  isOpenMobile,
  setIsOpenMobile,
  isMenuCollapsed,
  isUserSuperAdmin,
  isUserSalesAgent,
  setIsMenuCollapsed,
}) => (
  <SidebarWrapper
    isOpenMobile={isOpenMobile}
    collapsible={!isOpenMobile}
    collapsed={isMenuCollapsed}
    onCollapse={() => setIsMenuCollapsed(!isMenuCollapsed)}
  >
    <SidebarHeader
      collapsed={isMenuCollapsed}
    />

    <SidebarMenu
      {...{
        activeRoute,
        isOpenMobile,
        setIsOpenMobile,
        isMenuCollapsed,
        isUserSuperAdmin,
        isUserSalesAgent,
        collapsed: isMenuCollapsed,
        data: isUserSalesAgent ? sidebarLinksFirst.slice(0, -1) : sidebarLinksFirst,
      }}
    />
    {isUserSuperAdmin && (
      <Fragment>
        <Divider />

        <SidebarMenu
          {...{
            activeRoute,
            isOpenMobile,
            setIsOpenMobile,
            isMenuCollapsed,
            isUserSuperAdmin,
            isUserSalesAgent,
            collapsed: isMenuCollapsed,
            data: sidebarLinksSecond,
          }}
        />
      </Fragment >
    )}
  </SidebarWrapper>
);

Sidebar.propTypes = {
  route: string,
  children: any,
  isOpenMobile: bool.isRequired,
  isMenuCollapsed: bool.isRequired,
  setIsOpenMobile: func.isRequired,
  isUserSuperAdmin: bool.isRequired,
  isUserSalesAgent: bool.isRequired,
  setIsMenuCollapsed: func.isRequired,
};

Sidebar.defaultProps = {
  route: '',
  children: null,
};



// WEBPACK FOOTER //
// ./src/components/sidebar/index.js